/**
 * ProcessingRateLine — the published card-processing rate, one sentence (APP-ENTITLEMENT-001; owner ruling
 * Q-AE-11: Stripe's rate plus a console-set margin, published, the same for everyone). The catalog route answers
 * the summed rate; nothing is computed here.
 *
 * @module @puffin-core/marketing-shell/pricing/ProcessingRateLine
 */

import PropTypes from 'prop-types';

import { useMarketingShellTranslate } from '../hooks/useMarketingShellTranslate.js';

/** Basis points → the percent a person reads (`340` → `'3.4'`, `295` → `'2.95'`). */
export function percentOfBps(bps) {
  return String(bps / 100);
}

/**
 * @param {Object} props
 * @param {{rateBps: number, fixedCents: number}} props.processing - the public catalog's `processing`.
 * @param {(cents: number) => string} props.formatPrice
 * @param {Function} [props.t]
 * @returns {React.JSX.Element}
 */
export function ProcessingRateLine({ processing, formatPrice, t: hostT }) {
  const t = useMarketingShellTranslate(hostT);
  return (
    <p className="text-sm text-muted" data-testid="processing-rate">
      {t('pricing.processingRate', {
        rate: percentOfBps(processing.rateBps),
        fixed: formatPrice(processing.fixedCents),
      })}
    </p>
  );
}

ProcessingRateLine.propTypes = {
  processing: PropTypes.shape({
    rateBps: PropTypes.number.isRequired,
    fixedCents: PropTypes.number.isRequired,
  }).isRequired,
  formatPrice: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default ProcessingRateLine;
